import React from 'react';
import IIconSvg from './IIconSvg';
import Svg from '../Svg';

const Email: React.FC<IIconSvg> = ({ fill = '#E9314A', bgColor, size }) => (
  <Svg fill={fill} bgColor={bgColor} size={size} viewBox="0 0 70 72" path="">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9574 15.117C10.8692 15.9523 9.5 17.9747 9.5 20.2237V52.25C9.5 55.2876 11.9624 57.75 15 57.75H59C62.0377 57.75 64.5 55.2876 64.5 52.25V20.2237C64.5 17.9747 63.1308 15.9523 61.0427 15.117L40.0641 6.72559C38.097 5.93884 35.903 5.93884 33.936 6.72559L12.9574 15.117ZM22.4446 25.5554C21.3706 24.4815 19.6294 24.4815 18.5554 25.5554C17.4815 26.6294 17.4815 28.3706 18.5554 29.4445L31.1664 42.0555C34.3883 45.2774 39.6117 45.2774 42.8336 42.0555L55.4445 29.4445C56.5184 28.3706 56.5184 26.6294 55.4445 25.5554C54.3707 24.4815 52.6294 24.4815 51.5555 25.5554L38.9445 38.1664C37.8707 39.2403 36.1294 39.2403 35.0555 38.1664L22.4446 25.5554Z"
    />
    <circle cx="16" cy="56" r="16" fill="#FFEEF0" />
    <path d="M10.3224 65.6031L14.5803 60.0272L18.7876 65.6031L22.0317 63.2714L17.8245 57.6955L24.11 55.5666L22.8934 51.7648L16.5572 53.8431V47H12.5528V53.8431L6.21655 51.7648L5 55.5666L11.2855 57.6955L7.07828 63.2714L10.3224 65.6031Z" />
  </Svg>
);

export default Email;
